import React, { useState } from 'react'

// Local imports
import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'
import AdxButton from 'components/custom/AdxButton'

const ActionConfirmationModal = ({
  actionType,
  btnText = 'default',
  actionFn,
  mutation,
  sxButton,
}) => {
  const [modalState, setModalState] = useState(false)

  const handleOpen = () => {
    setModalState(true)
  }

  const handleClose = () => {
    setModalState(false)
  }

  if (actionType === 'REJECT') {
    return (
      <>
        <AdxButton
          variant={'outlined'}
          sx={{
            width: { xs: 1 / 3, lg: 'auto' },
            ...sxButton,
          }}
          onClick={handleOpen}
        >
          {btnText}
        </AdxButton>
        <AdxInfoModal
          variant={'error'}
          title="Are you sure you want to reject this request?"
          subtitle=""
          open={modalState}
          onClose={handleClose}
          handleClose={handleClose}
          muiIcon="error"
          iconColor="error.main"
          firstBtnLoading={mutation.isLoading}
          firstBtnDisabled={mutation.isLoading}
          footerButtons
          firstBtnLabel={'Reject'}
          firstBtnHandle={() => actionFn()}
          secondBtnLabel={'Cancel'}
          secondBtnHandle={handleClose}
        />
      </>
    )
  }

  if (actionType === 'APPROVE') {
    return (
      <>
        <AdxButton
          variant={'contained'}
          onClick={handleOpen}
          disableElevation
          sx={{
            width: { xs: 2 / 3, lg: 'auto' },
            '&:hover': {
              backgroundColor: 'primary.hover',
            },
            ...sxButton,
          }}
        >
          {btnText}
        </AdxButton>
        <AdxInfoModal
          title="Confirm Submission?"
          subtitle=""
          open={modalState}
          onClose={handleClose}
          handleClose={handleClose}
          muiIcon="info"
          iconColor="primary.main"
          firstBtnLoading={mutation.isLoading}
          firstBtnDisabled={mutation.isLoading}
          footerButtons
          firstBtnLabel={'Approve request'}
          firstBtnHandle={() => actionFn()}
          secondBtnLabel={'Cancel'}
          secondBtnHandle={handleClose}
        />
      </>
    )
  }

  return null
}

export default ActionConfirmationModal
